module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "foreword",
      "id": "_idContainer000",
      "role": "doc-foreword"
    }
  }, [_c('p', {
    staticClass: "pl-fl-header"
  }, [_vm._v("“Are you in some kind of trouble?” Cade finally asked.")]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_vm._v("Leah turned away. “Why would you ask that?”")]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_vm._v("“I don’t know. Something about the way you’ve acted since…well, since I pulled you from the snow. Like you’re scared. Why are you in such a hurry to leave? I thought you were staying in the cabin tonight?”")]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_vm._v("She glanced at him. “I never said I was staying. I asked you to give me a ride back, that’s all.”")]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_vm._v("“I just want to help.”")]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_vm._v("Leah sighed. “I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_vm._v("“I could take a look at it for you.” Now, why would he offer that up—an attempt to snag her?")]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_vm._v("“No.” Her reply was too emphatic.")]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_vm._v("He glanced her way, trying to watch her and the road. To his surprise, a timid smile broke through.")]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_vm._v("“Not tonight, that is,” she added. She was trying to be friendly, warm up to him, but still, it seemed forced.")]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_vm._v("He risked another glance over and caught her eyes—there he saw the truth. She was terrified and hiding something.")]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Who are you, Leah Marks?")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-374f0a11","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Introduction.vue
// module id = 60
// module chunks = 0